export default __webpack_public_path__ + "static/B0108-a08fed329c1575e24e820638076d6754.png";